import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Star,
  Award,
  Heart,
  Shield,
  Building2,
  Package,
  Stethoscope,
  PlusCircle,
  Baby,
  Bone,
  Brain,
  Microscope,
  ChevronRight,
  Download,
  CheckCircle,
  Trophy,
  BadgeIcon as Certificate,
  User,
  ArrowRight,
} from "lucide-react"
import { NewsletterForm } from "../newsletter-form"
import { Badge } from "../ui/badge"



export default function NewsLetterwidget() {
  return (
        <section className="py-12 bg-gray-100">
                  <div className="container px-4 mx-auto">
                    <div className="max-w-2xl mx-auto">
                      <div className="flex flex-col items-center text-center">
                        <Badge className="mb-2">Stay Updated</Badge>
                        <h2 className="mb-4 text-2xl font-bold md:text-3xl">Subscribe to Our Newsletter</h2>
                        <p className="mb-6 text-muted-foreground">
                          Get the latest health tips, hospital news, and special offers delivered to your inbox.
                        </p>
                      </div>
                      <NewsletterForm />
                    </div>
                  </div>
                </section>
    
  );
}

 